import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { CrudService, DialogService, MessageService, Notification, Page, Search, SharedDataService, Staff, TicketService, UiConf } from 'orv-ui-base-lib';
import { Subscription, timer } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthService } from '../../@core/auth/auth.service';
import { AclService } from '../../@core/data/acl.service';
import { ResponsiveCommon } from '../../@core/responsive.common';


@Component({
	selector: 'app-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent extends ResponsiveCommon implements AfterViewInit, OnDestroy, OnInit, OnChanges {

	// tslint:disable-next-line: no-input-rename
	@Input() loggedUser: Staff;
	@Output() logoHeightUpdate: EventEmitter<number> = new EventEmitter();
	@Output() showsidebar: EventEmitter<boolean> = new EventEmitter();
	@ViewChild('logoattach', { read: ElementRef }) logoattach: ElementRef;

	showHide: boolean = false;
	pageInfo: any;
	controlroommode: boolean = false;

	activeNotification: boolean = false;
	notifications: any[] = [];

	currentdate: number;

	timerRenew: Subscription;

	myTicketsNumber: number;
	uiconf: UiConf;

	dev: boolean;
	depots: string[];

	enviroment = environment;


	constructor(private logger: NGXLogger,
		private sharedDataService: SharedDataService,
		private crudServiceConf: CrudService<UiConf>,
		private messageService: MessageService,
		private dialogService: DialogService,
		private translateService: TranslateService,
		private authService: AuthService,
		private ticketService: TicketService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private aclService: AclService) {
		super();

		// routing
		this.router.events.filter(event => event instanceof NavigationEnd)
			.map((data) => {
				this.controlroommode = data['url'].includes('/control-room/');
				// console.log('test:', this.controlroommode);
				return data;
			})
			.map(() => this.activatedRoute)
			.map(route => {
				while (route.firstChild) {
					route = route.firstChild;
				}
				return route;
			}).filter(route => route.outlet === 'primary')
			.mergeMap(route => route.data)
			.subscribe(event => this.pageInfo = event);



		// notification
		this.sharedDataService.currentNotification.subscribe((notification: Notification) => {
			/* TODO: remove comment when backend ok
			if (notification) {
			  if (notification.alert === 1 || notification.alert === 2 || notification.alert === 3) {
				this.activeNotification = true;
				if (notification.alert === 3) {
				  this.messageService.sendNotification(notification.message, notification.type);
				}
			  } else if (notification.alert === 4) {
				this.dialogService.openAlertModal({
				  message: notification.message,
				  title: notification.type,
				  hasIcon: true,
				  type: 'warning'
				}).then(result => {
				  // TODO:
				});
			  }
			  // TODO: API
			  this.notifications.push({
				round: 'round-danger',
				icon: 'ti-link',
				title: notification.message,
				subject: notification.type
			  });
			}
			*/
		});

		this.depots = this.aclService.getDepots();
	}

	ngOnInit() {
		if (!this.responsive) this.showHide = this.authService.getSidebarCookie() === 'true' ? false : true;

		this.scheduleTimer();
		// console.log(environment);
		this.dev = environment.demo;
		this.sharedDataService.currentLoggedUser.subscribe(user => {
			if (user && user.guid) {
				this.loadUiConf(user.guid);
			} else {
				this.uiconf = undefined;
			}
		});

		this.sharedDataService.currentCommondata.subscribe(commondata => {
			if (commondata['uiconf']) {
				this.uiconf = commondata['uiconf'];
				// console.log('aaaaa', this.uiconf);
			}
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes && changes.loggedUser && changes.loggedUser.currentValue !== changes.loggedUser.previousValue) {
			this.loggedUser = changes.loggedUser.currentValue;
			if (this.loggedUser) this.setMyTicketsNumber();
		}
	}

	ngOnDestroy() {

		if (this.timerRenew) this.timerRenew.unsubscribe();
	}

	loadUiConf(guid: number) {
		const search = new Search('uiconf');
		search.addSimpleFilter('guid', guid);
		this.crudServiceConf.searchEntities(UiConf, 'uiconf', search, new Page(1)).subscribe(result => {
			this.uiconf = result[0];
			// console.log('aaaaa', this.uiconf);
		}, error => {
			console.log('error', error);
		});
	}

	onAttachDowloaded(event: any) {
		setTimeout(() => {
			this.logoHeightUpdate.emit(this.logoattach.nativeElement.offsetHeight);
		}, 500);
	}

	setMyTicketsNumber() {
		this.ticketService.countMyTickets(['agntid', 'onrid', 'usrid'], this.loggedUser.id).subscribe(
			result => {
				this.myTicketsNumber = result.ct;
			},
			({ error }) => {
				this.myTicketsNumber = 0;
				this.logger.log('%c ERROR COUNTING TICKETS', 'color:#FF2600', error);
			}
		);
	}

	scheduleTimer() {
		this.currentdate = new Date().getTime();

		this.timerRenew = timer(60000).subscribe(() => {
			this.timerRenew.unsubscribe();
			this.scheduleTimer();
		});
	}

	swicthMode(event) {
		if (!event) {
			this.router.navigateByUrl('/');
		} else {
			this.router.navigate(['control-room/dashboard'], {});
		}
	}

	changeShowStatus() {
		this.showHide = !this.showHide;
		this.authService.setSidebarCookie(!this.showHide ? 'true' : 'false');
		this.sharedDataService.sendAction('toggleside', this.showHide);
		if (this.responsive) this.showsidebar.emit(this.showHide);
	}

	ngAfterViewInit() {
		$(function () {
			$('.preloader').fadeOut();
		});

		const set = function () {
			const topOffset = 70;
			/*
			const width =
			  window.innerWidth > 0 ? window.innerWidth : this.screen.width;
			if (width < 1170) {
			  $('body').addClass('mini-sidebar');
			  $('.navbar-brand span').hide();
			  $('.scroll-sidebar, .slimScrollDiv')
				.css('overflow-x', 'visible')
				.parent()
				.css('overflow', 'visible');
			  $('.sidebartoggler i').addClass('ti-menu');
			} else {
			  $('body').removeClass('mini-sidebar');
			  $('.navbar-brand span').show();
			  $('.sidebartoggler i').removeClass('ti-menu');
			}
			*/

			const height =
				(window.innerHeight > 0 ? window.innerHeight : this.screen.height) - 1;

			if (height > topOffset) {
				$('.page-wrapper').css('min-height', height + 'px');
			}
		};
		$(window).ready(set);
		$(window).on('resize', set);

		$(document).on('click', '.mega-dropdown', function (e) {
			e.stopPropagation();
		});

		$('.search-box a, .search-box .app-search .srh-btn').on(
			'click',
			function () {
				$('.app-search').toggle(200);
			}
		);

		(<any>$('[data-toggle="tooltip"]')).tooltip();

		(<any>$('.scroll-sidebar')).slimScroll({
			position: 'left',
			size: '5px',
			height: '100%',
			color: '#dcdcdc'
		});

		(<any>$('.right-sidebar')).slimScroll({
			height: '100%',
			position: 'right',
			size: '5px',
			color: '#dcdcdc'
		});

		(<any>$('.message-center')).slimScroll({
			position: 'right',
			size: '5px',
			color: '#dcdcdc'
		});

		$('body').trigger('resize');
	}

}
